import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router';
import HubIcon from '@mui/icons-material/Hub';
import DashboardIcon from '@mui/icons-material/Dashboard';

interface DashboardLinkProps {
  linkto: string;
  title:  string;
  underline?: 'always' | 'hover' | 'none';
}

export default function DashboardLink({ linkto, title }: DashboardLinkProps) {
  const isOverview = linkto === 'overview';

  return (
    <Link to={`/${linkto}`} style={{ textDecoration: 'none' }}>
      <Box sx={{
        display:        'flex',
        alignItems:     'center',
        gap:            1.25,
        p:              '8px 12px',
        borderRadius:   2,
        background:     'var(--color-bg-secondary)',
        borderLeft:     '3px solid transparent',
        transition:     'all 0.18s ease',
        cursor:         'pointer',
        '&:hover': {
          borderLeftColor: '#1D9E75',
          background:      'var(--color-bg-tertiary)',
          transform:       'translateX(3px)',
        },
      }}>
        <Box sx={{
          color:      '#1D9E75',
          display:    'flex',
          alignItems: 'center',
          flexShrink: 0,
          '& svg': { fontSize: '16px !important', padding: 0 },
        }}>
          {isOverview ? <HubIcon /> : <DashboardIcon />}
        </Box>
        <Typography sx={{
          fontFamily: "'Syne', sans-serif",
          fontSize:   13,
          fontWeight: 500,
          color:      'var(--color-text-primary)',
          lineHeight: 1.3,
        }}>
          {title}
        </Typography>
      </Box>
    </Link>
  );
}
